<template>
  <div class="">
     <!-- 查询表单 -->
     <div>
      <el-form ref="tailiModelForm" :model="tailiModelForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="渠道名称">
                <el-input v-model="tailiModelForm.openName"></el-input>
            </el-form-item>
          </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
                <el-input v-model="tailiModelForm.categoryName"></el-input>
            </el-form-item>
          </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="品牌">
                <el-input v-model="tailiModelForm.brandName"></el-input>
            </el-form-item>
          </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="机型">
                <el-input v-model="tailiModelForm.modelName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getNewModelMappingList">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="openName"
            label="渠道名称">
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="brandName"
            label="品牌">
          </el-table-column>
          <el-table-column
            prop="modelId"
            label="机型ID">
          </el-table-column>
          <el-table-column
            prop="modelName"
            label="机型名称">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorBindModel(scope.row)" type="text" size="small">绑定机型</el-button>
                <el-button @click="ignoreModel(scope.row)" type="text" size="small">忽略机型</el-button>
               </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '绑定机型' : ''" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editTailiModelForm" :model="editTailiModelForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID">
              <el-input clearable v-model="editTailiModelForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="分类">
              <el-input clearable v-model="editTailiModelForm.categoryName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="品牌">
              <el-input clearable v-model="editTailiModelForm.brandName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="新机型ID">
              <el-input clearable v-model="editTailiModelForm.modelName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="新机型名称">
              <el-input clearable v-model="editTailiModelForm.modelName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="分类">
              <el-select
                v-model="editTailiModelForm.hjxCategoryId"
                placeholder="请选择"
                @change="
                  dlgChangeCategory(
                    'phoneBrand',
                    'dlgBrandOptions',
                    editTailiModelForm.hjxCategoryId
                  )
                "
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select
                v-model="editTailiModelForm.hjxBrandId"
                placeholder="请选择"
                @change="skuTree"
              >
                <el-option
                  v-for="item in dlgBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型">
              <el-select
                v-model="editTailiModelForm.hjxModelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in skuInfo.phoneModel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      tailiModelForm: {
        openName: null
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      tempGradeIdList:null,

      // 新建编辑对话框数据

      isDlg: false,
      editTailiModelForm: {
        id: null,
        categoryName:null,
        brandName:null,
        modeId:null,
        modelName:null,
        hjxCategoryId:null,
        hjxBrandId:null,
        hjxModelId:null
      },

      editorFormRules: {
      },
      dlgType: 'change',
      queryGradeList:[],
        // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      skuInfo:{}
    }
  },
  watch:{},
  computed:{},
  methods:{
    //获取品牌下的sku信息
    skuTree(val) {
      let self = this;
      self.$api
        .skuTree({
          brandId: val,
        })
        .then((res) => {
          self.skuInfo = res.data;
        });
    },
    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId);
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getNewModelMappingList()
    }, 

    // 获取门店列表
    getNewModelMappingList() {
      let self  = this;
      self.$api.listSearchNewModelMapping({
        page: self.currentPage,
        size: self.pageSize,
        openName: self.tailiModelForm.openName || null,
        categoryName: self.tailiModelForm.categoryName || null,
        modelName: self.tailiModelForm.modelName || null,
        brandName: self.tailiModelForm.brandName || null,
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 修改门店
    editorBindModel(row) {
      let self = this;
      self.editTailiModelForm=JSON.parse(JSON.stringify(row));
      self.dlgType = 'change'
      self.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    ignoreModel(row){
      let self = this
      self.$api.ignoreTailiModel({newModelMappingId:row.id}).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getNewModelMappingList()
              }
            })
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editTailiModelForm'].validate((valid) => {
        if (valid) {

          if(self.dlgType === 'change') {
            self.$api.bindTailiModel({newModelMappingId:self.editTailiModelForm.id,hjxModelId:self.editTailiModelForm.hjxModelId}).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getNewModelMappingList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getNewModelMappingList();
    self.getSelectOptions("category", "categoryOptions");
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>